import React, { Component } from "react";
import {Table} from "react-bootstrap";
// import Moment from "react-moment";
import { Link } from "react-router-dom";

class UserTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
        winter: "",
        spring: "",
        summer: "",
        late:'',
        fall:'',
        email:'',
        list:[]
    };

  }
  componentDidMount(){
    console.log("User Table mounted",this.props.answers);
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.answers !== prevProps.answers) {
      let cura=this.props.answers;
      console.log("current responses",cura);
      this.setState({list:cura});
    }
  }
  

  render() {
    function Td({ children, to }) {
      const content = <Link to={to}>{children}</Link>;

      return <td>{content}</td>;
    }

    //first if statement shows no Answers added if ther are no answers
    //Secon one maps objects with their indexes to the table
    const content =
      !this.props.answers || this.props.answers.length === 0 ? (
        <tr>
          <td>No {this.props.objecttype} added</td>
          {this.props.attributes.map((attribute, index) => (
            <td key={index}>No {this.props.objecttype} added</td>
          ))}
        </tr>
      ) : 
      // (
      //   this.props.answers.map((obj, index) => (
      //     <tr key={index}>
      //       <td>{index + 1}</td>
      //       {this.props.attributes.map((attribute, index2) => {
      //         // const currThis = this;
      //         if (attribute === "winter")
      //         // console.log("curr obj", obj);
      //         // console.log("curr attriburet",attribute);
      //         // console.log("curr index",index);
      //           return (
      //             <td key={index + 2} className="tg-list-item">

      //               {obj.winter}
                  

      //             </td>
      //           );
      //         return <td key={index2}>{obj[attribute]}</td>;
      //       })}
      //       <td>
      //         {obj.email}
      //       </td>
      //     </tr>
      //   ))
      // );
      (
        this.props.answers.map((obj, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td> {obj.winter}</td>
            <td> {obj.spring}</td>
            <td> {obj.summer}</td>
            <td> {obj.transition}</td>
            <td> {obj.fall}</td>

            <td> {obj.iwinter}</td>
            <td> {obj.ispring}</td>
            <td> {obj.isummer}</td>
            <td> {obj.itransition}</td>
            <td> {obj.ifall}</td>
            
            <td>
              {obj.email}
            </td>
            <td>
              {String(obj.createdAt).substring(0,10)}
            </td>
          </tr>
        ))
      );

    return (
      <div className="content">
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>#</th>
              {this.props.attributes.map((attribute, index) => (
                <th key={index}>{attribute}</th>
              ))}
              <th>Email</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>{content}</tbody>
        </Table>

       
      </div>
    );
  }
}

export default UserTable;



// WEBPACK FOOTER //
// ./src/components/Table/UserTable.jsx